import { z } from 'zod'

import { DateStringSchema, type ZodInfer } from '@mntn-dev/utility-types'

import { ChargeStatusSchema } from '../billing/charge-status.ts'
import { PaymentGatewaySchema } from '../billing/payment-gateway.ts'
import { UbsInvoiceIdSchema } from './ubs-invoice-id.ts'
import { UbsPaymentIdSchema } from './ubs-payment-id.ts'

export const UbsPaymentSchema = z.object({
  paymentId: UbsPaymentIdSchema,
  invoiceId: UbsInvoiceIdSchema,
  gateway: PaymentGatewaySchema,
  amount: z.number(),
  status: ChargeStatusSchema,
  processedAt: DateStringSchema,
  createdAt: DateStringSchema,
  metadata: z.record(z.string(), z.any()),
})

export type UbsPayment = ZodInfer<typeof UbsPaymentSchema>
